import { GridFilterItem } from "@mui/x-data-grid";

export * as AccountProgramAPI from "./accountPrograms";
export * as AccountAPI from "./accounts";
export * as AccountTypeAPI from "./accountTypes";
export * as AddressAPI from "./address";
export * as ApiKeyAPI from "./apikey";
export * as AuditAPI from "./audit";
export * as ChatAPI from "./chat";
export * as ContactAPI from "./contactInfo";
export * as CopilotAPI from "./copilot";
export * as CopilotChatAPI from "./copilotChat";
export * as DashboardAPI from "./dashboards";
export * as EmailFilterAPI from "./emailFilters";
export * as ExecutorAPI from "./executors";
export * as FieldDefinitionAPI from "./fieldDefinitions";
export * as FileAPI from "./file";
export * from "./integrations";
export * as InvitationAPI from "./invitations";
export * as MaintenanceMessageAPI from "./maintenanceMessages";
export * as MetricsAPI from "./metric";
export * as NotificationAPI from "./notification";
export * as OrganizationRoleAPI from "./organizationRoles";
export * as OrganizationAPI from "./organizations";
export * as PreferenceAPI from "./preferences";
export * as ProcessExecutionAPI from "./process_executions";
export * as ProcessCategoryAPI from "./processCategories";
export * as ProcessAPI from "./processes";
export * as PublicProcessExecutionAPI from "./public_executor";
export * as RoleAPI from "./roles";
export * as TaskExecutionAPI from "./taskExecutions";
export * as TaskAPI from "./tasks";
export * as UserAPI from "./users";

export type Pagination = {
  offset?: number;
  total?: number;
  pageSize: number;
};

export type ResponseEnvelope<PayloadType> = {
  requestId: string;
  payload: PayloadType | null;
  pagination?: Pagination;
};
export type PagedResponse<T> = {
  total_count: number;
  data: Array<T>;
};

export type FilterOperator = "=" | "not in" | "!=";

export type Filter = {
  field: string;
  operator: FilterOperator;
  value?: string | string[];
};

const FILTER_OPERATOR_MAP = {
  equals: "=",
} as const;

type GridFilterOperator = keyof typeof FILTER_OPERATOR_MAP;

const toFilterOperator = (operator: GridFilterOperator) => {
  return FILTER_OPERATOR_MAP[operator] ?? operator;
};

export const toFilter = (gridFilter: GridFilterItem) => {
  return {
    field: gridFilter.field,
    operator: toFilterOperator(gridFilter.operator as GridFilterOperator),
    value: gridFilter.value,
  };
};
